import { FC } from 'react';
import {
  AllieSelectProps,
  AllieText,
  AllieTextProps,
  LabeledSelectContainerProps,
} from '../../components';
import { LabeledSelectContainer, SelectStyled } from './LabeledSelect.styles';

interface AllieLabeledSelectProps extends AllieSelectProps {
  label: string;
  containerProps?: LabeledSelectContainerProps;
  textProps?: AllieTextProps;
}

export const AllieLabeledSelect: FC<AllieLabeledSelectProps> = ({
  label,
  containerProps,
  textProps,
  ...props
}) => {
  return (
    <LabeledSelectContainer {...containerProps}>
      {label && (
        <AllieText type="body2" color="neutral-50" {...textProps}>
          {label}
        </AllieText>
      )}
      <SelectStyled
        interfaceOptions={{
          arrow: false,
          size: 'auto',
        }}
        {...props}
      />
    </LabeledSelectContainer>
  );
};
